import { useEffect, useState } from "react";
import { Download, FileText, Loader2 } from "lucide-react";
import { errText, papi } from "../portalApi";

const kb = (b) => (!b ? "" : b < 1048576 ? `${Math.round(b / 1024)} KB` : `${(b / 1048576).toFixed(1)} MB`);

/* One broadcast attachment, fetched with the Hub login (picture / video inline, others as download). */
export const NewsMedia = ({ bid, n, f, fetcher }) => {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const get = fetcher || ((p) => papi("get", p, null, { responseType: "blob" }));
  const path = `/news/${bid}/file/${n}`;
  const inline = f.file_type === "image" || f.file_type === "video";
  useEffect(() => {
    if (!inline) return undefined;
    let u = "";
    get(path).then((b) => { u = URL.createObjectURL(b); setUrl(u); }).catch(() => {});
    return () => u && URL.revokeObjectURL(u);
  }, [bid, n]);
  const download = async () => {
    setBusy(true);
    try {
      const b = await get(path);
      const a = document.createElement("a");
      a.href = URL.createObjectURL(b); a.download = f.file_name || "file"; a.click();
    } catch (e) { alert(errText(e)); } finally { setBusy(false); }
  };
  if (f.file_type === "image") return url ? <img src={url} alt={f.file_name} className="max-h-96 w-auto rounded-lg border" data-testid={`news-img-${bid}-${n}`} /> : <div className="h-40 w-full animate-pulse rounded-lg bg-slate-100" />;
  if (f.file_type === "video") return url ? <video src={url} controls className="max-h-96 w-full rounded-lg border bg-black" data-testid={`news-video-${bid}-${n}`} /> : <div className="h-40 w-full animate-pulse rounded-lg bg-slate-100" />;
  return (
    <button onClick={download} className="flex w-full items-center gap-3 rounded-lg border bg-white px-3 py-2 text-left hover:bg-slate-50" data-testid={`news-file-${bid}-${n}`}>
      <FileText className="h-5 w-5 text-teal-600" />
      <span className="min-w-0 flex-1"><span className="block truncate text-sm font-medium">{f.file_name}</span><span className="text-[11px] text-slate-500">{kb(f.file_size)}</span></span>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4 text-slate-400" />}
    </button>
  );
};
